var m = require('mithril');
var prop = require('mithril/stream');
var key = require('../libs/keybindings');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var equipmentClassTree = require('./equipmentClassTree');
var treeLocationRoom = require('../locations/treeLocationRoom');
var equipmentModel = require('./models/equipment');
var loaders = require('../layout/components/loaders');
var fileInput = require('../components/inputs/fileInput');
var ToggleSwitch = require('../components/toggleSwitch');
var templateDeviceSelector = require('../binding/components/templateDeviceSelector');
var templateInputModeTabs = require('../binding/components/templateInputModeTabs');

var AddCustomEquipmentModal = Object.assign(Object.create(Model), require('../../../../models/equipment/customEquipment'));

modal.once('closed', function () {
  key.deleteScope('modal');
  key.setScope('home');
});


AddCustomEquipmentModal.editDialogue = function (record, locationRecord, parentEquipment, options) {

  Model.initForm.call(AddCustomEquipmentModal, record);
  locationRecord && locationRecord['@rid'] ? AddCustomEquipmentModal.form.location(locationRecord['@rid']) : '';
  parentEquipment && parentEquipment['@rid'] ? AddCustomEquipmentModal.form.parentEquipment(parentEquipment['@rid']) : '';
  AddCustomEquipmentModal.classData = prop(null);
  AddCustomEquipmentModal.templateOptions = prop([]);
  AddCustomEquipmentModal.selectedTemplateEquipmentRid = prop('');
  AddCustomEquipmentModal.templateRoomOptions = prop([]);
  AddCustomEquipmentModal.templateRequiresRoomSelection = prop(false);
  AddCustomEquipmentModal.selectedTemplateRoom = prop('');
  AddCustomEquipmentModal.bindingTemplate = prop('');
  AddCustomEquipmentModal.bindingTemplateMode = prop('template');
  AddCustomEquipmentModal.bindingTemplateContent = prop('');
  AddCustomEquipmentModal.bindingTemplateFileName = prop('');
  AddCustomEquipmentModal.bindingTemplateLoading = prop(false);
  AddCustomEquipmentModal.bindingTemplateLoadError = prop('');
  AddCustomEquipmentModal.bindingTemplateLoadRequestId = prop(0);
  AddCustomEquipmentModal.bindingTargetDeviceIds = prop('');
  AddCustomEquipmentModal.bindingRequiredDevices = prop([]);
  AddCustomEquipmentModal.bindingTemplateDeviceParseError = prop('');
  AddCustomEquipmentModal.bindingDeviceSelections = prop([]);
  AddCustomEquipmentModal.bindingExpandedDeviceIndex = prop(-1);
  AddCustomEquipmentModal.bindingSelectedDevice = prop(null);
  AddCustomEquipmentModal.bindingOverrideSelections = prop([{
    templateKey: 'override-device-0',
    rid: '',
    name: '',
    path: ''
  }]);
  AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex = prop(-1);
  AddCustomEquipmentModal.bindingOverrideSelectedDevice = prop(null);
  AddCustomEquipmentModal.bindingResult = prop(null);
  AddCustomEquipmentModal.applyBindingAfterCreate = prop(false);
  AddCustomEquipmentModal.createdEquipmentRecord = prop(null);
  AddCustomEquipmentModal.templateDetailsRequestId = 0;
  AddCustomEquipmentModal.findedCategory = prop();

  AddCustomEquipmentModal.syncClassSelection = function (selectedClass) {
    var classData = selectedClass ? equipmentModel.findClassData(selectedClass) : null;
    AddCustomEquipmentModal.classData(classData || null);
    var templates = normalizeTemplateEntries(classData && classData.data ? classData.data.templates : []);
    AddCustomEquipmentModal.templateOptions(templates.filter(function (template) {
      return Boolean(template.equipmentRid);
    }));
    AddCustomEquipmentModal.selectedTemplateEquipmentRid('');
    AddCustomEquipmentModal.templateRoomOptions([]);
    AddCustomEquipmentModal.templateRequiresRoomSelection(false);
    AddCustomEquipmentModal.selectedTemplateRoom('');
    AddCustomEquipmentModal.bindingTemplate('');
    AddCustomEquipmentModal.bindingTemplateMode('template');
    AddCustomEquipmentModal.bindingTemplateContent('');
    AddCustomEquipmentModal.bindingTemplateFileName('');
    AddCustomEquipmentModal.bindingTemplateLoading(false);
    AddCustomEquipmentModal.bindingTemplateLoadError('');
    AddCustomEquipmentModal.bindingTemplateLoadRequestId(0);
    AddCustomEquipmentModal.bindingTargetDeviceIds('');
    AddCustomEquipmentModal.bindingRequiredDevices([]);
    AddCustomEquipmentModal.bindingTemplateDeviceParseError('');
    AddCustomEquipmentModal.bindingDeviceSelections([]);
    AddCustomEquipmentModal.bindingExpandedDeviceIndex(-1);
    AddCustomEquipmentModal.bindingSelectedDevice(null);
    AddCustomEquipmentModal.bindingOverrideSelections([{
      templateKey: 'override-device-0',
      rid: '',
      name: '',
      path: ''
    }]);
    AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(-1);
    AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
    AddCustomEquipmentModal.bindingResult(null);
    AddCustomEquipmentModal.applyBindingAfterCreate(false);
    AddCustomEquipmentModal.createdEquipmentRecord(null);
    AddCustomEquipmentModal.errors = [];
  };

  AddCustomEquipmentModal.selectTemplate = function (templateEquipmentRid) {
    AddCustomEquipmentModal.selectedTemplateEquipmentRid(templateEquipmentRid || '');
    AddCustomEquipmentModal.templateRoomOptions([]);
    AddCustomEquipmentModal.templateRequiresRoomSelection(false);
    AddCustomEquipmentModal.selectedTemplateRoom('');
    AddCustomEquipmentModal.bindingResult(null);
    AddCustomEquipmentModal.errors = [];

    if (templateEquipmentRid) {
      var selectedTemplate = (AddCustomEquipmentModal.templateOptions() || []).find(function (templateOption) {
        return templateOption && templateOption.equipmentRid === templateEquipmentRid;
      });
      AddCustomEquipmentModal.bindingTemplate(getBindingTemplateSelector(selectedTemplate));
    } else {
      AddCustomEquipmentModal.bindingTemplate('');
      AddCustomEquipmentModal.bindingTemplateMode('template');
      AddCustomEquipmentModal.bindingTemplateContent('');
      AddCustomEquipmentModal.bindingTemplateFileName('');
      AddCustomEquipmentModal.bindingTemplateLoading(false);
      AddCustomEquipmentModal.bindingTemplateLoadError('');
      AddCustomEquipmentModal.bindingTemplateLoadRequestId(0);
      AddCustomEquipmentModal.bindingTargetDeviceIds('');
      AddCustomEquipmentModal.bindingRequiredDevices([]);
      AddCustomEquipmentModal.bindingTemplateDeviceParseError('');
      AddCustomEquipmentModal.bindingDeviceSelections([]);
      AddCustomEquipmentModal.bindingExpandedDeviceIndex(-1);
      AddCustomEquipmentModal.bindingSelectedDevice(null);
      AddCustomEquipmentModal.bindingOverrideSelections([{
        templateKey: 'override-device-0',
        rid: '',
        name: '',
        path: ''
      }]);
      AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(-1);
      AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
      AddCustomEquipmentModal.applyBindingAfterCreate(false);
    }

    if (String(AddCustomEquipmentModal.bindingTemplateMode() || 'template').trim() === 'template') {
      AddCustomEquipmentModal.loadBindingTemplateFromSelectedTemplate();
    } else {
      AddCustomEquipmentModal.syncBindingRequiredDevices();
    }

    if (!templateEquipmentRid) {
      return Promise.resolve();
    }

    var requestId = AddCustomEquipmentModal.templateDetailsRequestId + 1;
    AddCustomEquipmentModal.templateDetailsRequestId = requestId;
    return loaders.requestWithLoader({
      loader: 'background',
      method: 'GET',
      url: '/api/v1/equipment/' + normalizeTemplateRidParam(templateEquipmentRid)
    })
    .then(function (templateEquipmentRecord) {
      if (requestId !== AddCustomEquipmentModal.templateDetailsRequestId) return;
      var roomOptions = extractTemplateRoomOptions(templateEquipmentRecord);
      AddCustomEquipmentModal.templateRoomOptions(roomOptions);
      AddCustomEquipmentModal.templateRequiresRoomSelection(roomOptions.length > 0);
    })
    .catch(function () {
      if (requestId !== AddCustomEquipmentModal.templateDetailsRequestId) return;
      AddCustomEquipmentModal.templateRoomOptions([]);
      AddCustomEquipmentModal.templateRequiresRoomSelection(false);
      AddCustomEquipmentModal.errors = ['Unable to load selected template details.'];
      m.redraw();
    });
  };

  AddCustomEquipmentModal.resolveSelectedBindingTemplateOption = function () {
    var selector = String(AddCustomEquipmentModal.bindingTemplate() || '').trim();
    if (!selector) return null;
    var templates = AddCustomEquipmentModal.templateOptions() || [];
    var selectedTemplate = templates.find(function (templateOption) {
      return getBindingTemplateSelector(templateOption) === selector;
    });
    return selectedTemplate || null;
  };

  AddCustomEquipmentModal.loadBindingTemplateFromSelectedTemplate = function () {
    var selectedTemplateOption = AddCustomEquipmentModal.resolveSelectedBindingTemplateOption();
    var sourceEquipmentId = formatTemplateId(selectedTemplateOption && selectedTemplateOption.equipmentRid);

    AddCustomEquipmentModal.bindingTemplateLoadError('');
    if (!sourceEquipmentId) {
      AddCustomEquipmentModal.bindingTemplateLoading(false);
      AddCustomEquipmentModal.bindingTemplateContent('');
      AddCustomEquipmentModal.bindingTemplateFileName('');
      AddCustomEquipmentModal.syncBindingRequiredDevices();
      m.redraw();
      return Promise.resolve();
    }

    var requestId = AddCustomEquipmentModal.bindingTemplateLoadRequestId() + 1;
    AddCustomEquipmentModal.bindingTemplateLoadRequestId(requestId);
    AddCustomEquipmentModal.bindingTemplateLoading(true);
    AddCustomEquipmentModal.bindingTemplateContent('');
    AddCustomEquipmentModal.bindingTemplateFileName('');
    AddCustomEquipmentModal.syncBindingRequiredDevices();
    m.redraw();

    return loaders.requestWithLoader({
      loader: 'background',
      method: 'POST',
      url: '/api/v1/binding/run',
      body: {
        command: 'export-template',
        options: {
          sourceEquipmentId: sourceEquipmentId
        }
      }
    })
      .then(function (response) {
        if (requestId !== AddCustomEquipmentModal.bindingTemplateLoadRequestId()) return;
        if (!response || !response.download || !response.download.base64) {
          throw new Error('Template export did not return JSON content.');
        }
        var byteArray = base64ToUint8Array(response.download.base64);
        var rawText = decodeByteArrayToText(byteArray);
        var templateText = rawText;
        try {
          templateText = JSON.stringify(JSON.parse(rawText), null, 2);
        } catch (error) {}
        AddCustomEquipmentModal.bindingTemplateContent(templateText);
        AddCustomEquipmentModal.bindingTemplateFileName(formatTemplateOptionLabel(selectedTemplateOption));
      })
      .catch(function (error) {
        if (requestId !== AddCustomEquipmentModal.bindingTemplateLoadRequestId()) return;
        AddCustomEquipmentModal.bindingTemplateLoadError(extractFirstErrorMessage(error) || 'Unable to load selected template JSON.');
        AddCustomEquipmentModal.bindingTemplateContent('');
        AddCustomEquipmentModal.bindingTemplateFileName('');
      })
      .finally(function () {
        if (requestId !== AddCustomEquipmentModal.bindingTemplateLoadRequestId()) return;
        AddCustomEquipmentModal.bindingTemplateLoading(false);
        AddCustomEquipmentModal.syncBindingRequiredDevices();
        m.redraw();
      });
  };

  AddCustomEquipmentModal.setBindingTemplateSelection = function (selector) {
    AddCustomEquipmentModal.bindingTemplate(selector || '');
    AddCustomEquipmentModal.errors = [];
    AddCustomEquipmentModal.bindingResult(null);
    AddCustomEquipmentModal.bindingTemplateLoadError('');
    if (String(AddCustomEquipmentModal.bindingTemplateMode() || 'template').trim() === 'template') {
      return AddCustomEquipmentModal.loadBindingTemplateFromSelectedTemplate();
    }
    AddCustomEquipmentModal.syncBindingRequiredDevices();
    return Promise.resolve();
  };

  AddCustomEquipmentModal.setBindingTemplateMode = function (mode) {
    AddCustomEquipmentModal.bindingTemplateMode(mode);
    AddCustomEquipmentModal.errors = [];
    AddCustomEquipmentModal.bindingResult(null);
    AddCustomEquipmentModal.bindingTemplateLoadError('');
    if (mode === 'template') {
      return AddCustomEquipmentModal.loadBindingTemplateFromSelectedTemplate();
    }
    AddCustomEquipmentModal.bindingTemplateLoadRequestId(AddCustomEquipmentModal.bindingTemplateLoadRequestId() + 1);
    AddCustomEquipmentModal.bindingTemplateLoading(false);
    if (mode !== 'upload') {
      AddCustomEquipmentModal.bindingTemplateFileName('');
    }
    if (mode !== 'paste' && mode !== 'upload') {
      AddCustomEquipmentModal.bindingTemplateContent('');
      AddCustomEquipmentModal.bindingTemplateFileName('');
    }
    AddCustomEquipmentModal.syncBindingRequiredDevices();
  };

  AddCustomEquipmentModal.setBindingTemplateFile = function (file) {
    if (!file) {
      AddCustomEquipmentModal.bindingTemplateFileName('');
      AddCustomEquipmentModal.bindingTemplateContent('');
      AddCustomEquipmentModal.syncBindingRequiredDevices();
      return;
    }
    var reader = new FileReader();
    reader.onload = function (event) {
      AddCustomEquipmentModal.bindingTemplateFileName(file.name || '');
      AddCustomEquipmentModal.bindingTemplateContent((event && event.target && event.target.result) ? event.target.result : '');
      AddCustomEquipmentModal.syncBindingRequiredDevices();
      AddCustomEquipmentModal.errors = [];
      AddCustomEquipmentModal.bindingResult(null);
      m.redraw();
    };
    reader.readAsText(file);
  };

  AddCustomEquipmentModal.syncBindingRequiredDevices = function () {
    var mode = String(AddCustomEquipmentModal.bindingTemplateMode() || 'template').trim();
    var templateContent = (mode === 'template' || mode === 'paste' || mode === 'upload')
      ? AddCustomEquipmentModal.bindingTemplateContent()
      : '';
    var parsed = templateDeviceSelector.parseRequiredDevicesFromTemplateText(templateContent);
    var requiredDevices = parsed && Array.isArray(parsed.devices) ? parsed.devices : [];
    AddCustomEquipmentModal.bindingRequiredDevices(requiredDevices);
    AddCustomEquipmentModal.bindingTemplateDeviceParseError(parsed && parsed.error ? parsed.error : '');
    AddCustomEquipmentModal.bindingDeviceSelections(
      templateDeviceSelector.buildSelectionList(
        requiredDevices,
        AddCustomEquipmentModal.bindingTargetDeviceIds(),
        AddCustomEquipmentModal.bindingDeviceSelections(),
        { preserveCustomRows: true }
      )
    );
    if (AddCustomEquipmentModal.bindingExpandedDeviceIndex() >= requiredDevices.length) {
      AddCustomEquipmentModal.bindingExpandedDeviceIndex(-1);
      AddCustomEquipmentModal.bindingSelectedDevice(null);
    }
    if (requiredDevices.length) {
      AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(-1);
      AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
    } else {
      var seededOverrideSelections = templateDeviceSelector.parseDeviceIdList(AddCustomEquipmentModal.bindingTargetDeviceIds())
        .map(function (rid, idx) {
          return {
            templateKey: 'override-seeded-' + idx,
            rid: rid,
            name: '',
            path: ''
          };
        });
      var baseOverrideSelections = AddCustomEquipmentModal.bindingOverrideSelections().length
        ? AddCustomEquipmentModal.bindingOverrideSelections()
        : seededOverrideSelections;
      var nextOverrideSelections = templateDeviceSelector.buildSelectionList(
        [],
        AddCustomEquipmentModal.bindingTargetDeviceIds(),
        baseOverrideSelections,
        { preserveCustomRows: true }
      );
      if (!nextOverrideSelections.length) {
        nextOverrideSelections = [{
          templateKey: 'override-device-0',
          rid: '',
          name: '',
          path: ''
        }];
      }
      AddCustomEquipmentModal.bindingOverrideSelections(nextOverrideSelections);
    }
  };

  AddCustomEquipmentModal.syncClassSelection(AddCustomEquipmentModal.form.equipmentClass());
  AddCustomEquipmentModal.syncBindingRequiredDevices();


  var submit = function () {
    AddCustomEquipmentModal.errors = [];
    AddCustomEquipmentModal.bindingResult(null);
    var selectedEquipmentClass = String(AddCustomEquipmentModal.form.equipmentClass() || '').trim();
    if (!selectedEquipmentClass) {
      AddCustomEquipmentModal.errors = ['Select an equipment class before saving.'];
      m.redraw();
      return;
    }
    AddCustomEquipmentModal.form.equipmentClass(selectedEquipmentClass);

    if (AddCustomEquipmentModal.classData() && AddCustomEquipmentModal.classData().codedModule) {
      AddCustomEquipmentModal.url = AddCustomEquipmentModal.classData().name;
    }

    if (AddCustomEquipmentModal.selectedTemplateEquipmentRid() && AddCustomEquipmentModal.applyBindingAfterCreate()) {
      var bindingMode = String(AddCustomEquipmentModal.bindingTemplateMode() || 'template').trim();
      if ((bindingMode === 'paste' || bindingMode === 'upload') && !String(AddCustomEquipmentModal.bindingTemplateContent() || '').trim()) {
        AddCustomEquipmentModal.errors = ['Template JSON Content is required for binding.'];
        m.redraw();
        return;
      }
    }

    var createOrReuseEquipment = function () {
      var existingCreatedEquipment = AddCustomEquipmentModal.createdEquipmentRecord();
      if (existingCreatedEquipment && existingCreatedEquipment['@rid']) {
        return Promise.resolve({ record: existingCreatedEquipment, createdNow: false });
      }

      var body = {};
      Object.keys(AddCustomEquipmentModal.form).forEach(key => {
        if (AddCustomEquipmentModal.form[key]() || key == 'noChildrenDatasets' || key == 'showInSummary') {
          body[key] = AddCustomEquipmentModal.form[key]();
        }
      });

      if (AddCustomEquipmentModal.selectedTemplateEquipmentRid()) {
        body.templateEquipmentRid = AddCustomEquipmentModal.selectedTemplateEquipmentRid();
      }

      if (AddCustomEquipmentModal.templateRequiresRoomSelection()) {
        var selectedRoom = AddCustomEquipmentModal.selectedTemplateRoom();
        if (!selectedRoom || !selectedRoom['@rid']) {
          AddCustomEquipmentModal.errors = ['Select a room to map template room links and feeds edges.'];
          m.redraw();
          return Promise.resolve(null);
        }
        body.templateRoomRid = selectedRoom['@rid'];
      }

      return loaders.requestWithLoader({
        loader: 'main',
        method: 'POST',
        url: '/api/v1/customequipment',
        body,
      })
      .then(response => {
        const promises = [];
        if (options && options.addToSystem) {
          const addToSystemRequest = loaders.requestWithLoader({
            loader: 'main',
            method: 'POST',
            url: '/api/v1/hasEquipment',
            body: {
              parentSystem: options.addToSystem['@rid'],
              childEquipment: response['@rid']
            }
          });
          promises.push(addToSystemRequest);
        }
        return Promise.all(promises).then(() => response);
      })
      .then(response => {
        AddCustomEquipmentModal.createdEquipmentRecord(response);
        return {
          record: response,
          createdNow: true
        };
      });
    };

    var applyBindingToCreatedEquipment = function (createdRecord) {
      var bindingMode = String(AddCustomEquipmentModal.bindingTemplateMode() || 'template').trim();
      var selector = bindingMode === 'template' ? String(AddCustomEquipmentModal.bindingTemplate() || '').trim() : '';
      var templateContent = bindingMode !== 'template' ? String(AddCustomEquipmentModal.bindingTemplateContent() || '').trim() : '';
      if (!selector && !templateContent) return Promise.resolve(null);

      return loaders.requestWithLoader({
        loader: 'main',
        method: 'POST',
        url: '/api/v1/location/equipment/bulk-bind',
        body: {
          created: [{
            rid: createdRecord['@rid'],
            class: createdRecord['@class'] || String(AddCustomEquipmentModal.form.equipmentClass() || '').trim(),
            name: createdRecord.name || String(AddCustomEquipmentModal.form.name() || '').trim(),
            row: 1
          }],
          bindingTemplate: selector,
          templateContent: templateContent,
          targetDeviceIds: String(AddCustomEquipmentModal.bindingTargetDeviceIds() || '').trim()
        }
      });
    };

    return createOrReuseEquipment()
    .then(result => {
      if (!result || !result.record || !result.record['@rid']) return null;
      if (result.createdNow && options && options.submitCallback) {
        options.submitCallback(result.record);
      }
      return Promise.resolve()
      .then(() => {
        if (!AddCustomEquipmentModal.selectedTemplateEquipmentRid() || AddCustomEquipmentModal.applyBindingAfterCreate() !== true) return null;
        return applyBindingToCreatedEquipment(result.record);
      })
      .then(bindingResponse => {
        if (!bindingResponse) {
          key.unbind('enter');
          modal.vm.close();
          return;
        }

        result.record.binding = bindingResponse;
        AddCustomEquipmentModal.bindingResult(bindingResponse);

        var hasBindingFailures = (bindingResponse.success === false) || (Number(bindingResponse.failedCount || 0) > 0);
        if (hasBindingFailures) {
          AddCustomEquipmentModal.errors = bindingSummaryToMessages(bindingResponse);
          m.redraw();
          return;
        }

        if (!result.createdNow && options && options.submitCallback) {
          options.submitCallback(result.record);
        }
        key.unbind('enter');
        modal.vm.close();
      })
      .catch(bindingError => {
        AddCustomEquipmentModal.errors = bindingErrorToMessages(bindingError);
        m.redraw();
      });
    })
    .catch(error => {
      AddCustomEquipmentModal.errors = extractRequestErrors(error);
      console.error('Error:', error);
      m.redraw();
    });
  };

  key.setScope('modal');
  key('enter', 'modal', submit);
  modal.vm.title(record ? 'Edit '+record['@class']+': ' : 'Create Equipment: ')
  modal.vm.body = AddCustomEquipmentModal.view,
  modal.vm.buttons([
    {
      label: "Save",
      class: record ? "dib mr2 ": "btn-good",
      func: submit
    }
  ]);
  modal.vm.open({
    extrawidth: true
  });
}


AddCustomEquipmentModal.view = function () {
  var templateRoomLabels = (AddCustomEquipmentModal.templateRoomOptions() || [])
    .map(formatTemplateRoomLabel)
    .filter(Boolean);
  var requiredRoomCount = templateRoomLabels.length;
  var templateRoomLabelText = templateRoomLabels.join(', ');
  var requiredRoomText = 'At least ' + requiredRoomCount + ' rooms required by the template. Template uses ' + templateRoomLabelText + '.';

  return m('form', {role:'form'}, [
    m('label',`Name:`),
    m('input.form-control.mb2', {
      type:'text',
      oninput: (ev) => AddCustomEquipmentModal.form['name'](ev.target.value),
      value: AddCustomEquipmentModal.form['name'](),
    }),
    AddCustomEquipmentModal.errorView(),
    m(equipmentClassTree, {
      equipmentClass: AddCustomEquipmentModal.form.equipmentClass,
      onClassChange: function (className) {
        AddCustomEquipmentModal.syncClassSelection(className);
      }
    }),
    AddCustomEquipmentModal.form.equipmentClass()
      ? m('div.mt2', [
        m('label.db.mb1', 'Template:'),
        m('select.form-control.w-100', {
          value: AddCustomEquipmentModal.selectedTemplateEquipmentRid(),
          onchange: function (event) {
            AddCustomEquipmentModal.selectTemplate(event && event.target ? event.target.value : '');
          }
        }, [
          m('option', { value: '' }, 'Blank'),
          AddCustomEquipmentModal.templateOptions().map(function (templateOption) {
            return m(
              'option',
              { value: templateOption.equipmentRid, key: templateOption.equipmentRid },
              formatTemplateOptionLabel(templateOption)
            );
          })
        ]),
        m('div.f6.gray.mt1', 'Selecting a template will copy its structure (children, datasets, and columns).')
      ])
      : '',
    AddCustomEquipmentModal.selectedTemplateEquipmentRid() && AddCustomEquipmentModal.templateRequiresRoomSelection()
      ? m('div.mt3.ba.b--moon-gray.br2.pa3', [
        m('label.db.mb1', 'Room (Required)'),
        m('div.f6.gray.mb2', requiredRoomText),
        m(treeLocationRoom, {
          selectedNode: AddCustomEquipmentModal.selectedTemplateRoom
        })
      ])
      : '',
    AddCustomEquipmentModal.selectedTemplateEquipmentRid()
      ? m('div.mt3.ba.b--moon-gray.br2.pa3', [
        m('div.flex.items-center.justify-between.mb2', [
          m('div.f6.b', 'Binding (Optional)'),
          m(ToggleSwitch, {
            id: 'create-equipment-apply-binding-toggle',
            checked: AddCustomEquipmentModal.applyBindingAfterCreate() === true,
            ariaLabel: 'Apply bindings after creating equipment',
            onchange: function () {
              AddCustomEquipmentModal.applyBindingAfterCreate(!AddCustomEquipmentModal.applyBindingAfterCreate());
            }
          })
        ]),
        AddCustomEquipmentModal.applyBindingAfterCreate()
          ? m('div', [
            m('div.f6.gray.mb2', 'Bind the equipment based on the template selected.'),
            m(templateInputModeTabs, {
              className: 'flex items-center mb2',
              activeKey: AddCustomEquipmentModal.bindingTemplateMode(),
              onSelect: AddCustomEquipmentModal.setBindingTemplateMode,
              tabs: [
                { key: 'template', label: 'Stored Templates' },
                { key: 'paste', label: 'Paste JSON' },
                { key: 'upload', label: 'Upload File' }
              ]
            }),
            AddCustomEquipmentModal.bindingTemplateMode() === 'template'
              ? m('div', [
                m('label.db.f5.mb1', { for: 'create-equipment-binding-template' }, 'Binding Template'),
                m('select#create-equipment-binding-template.w-100.ba.b--mid-gray.br2.pa2.mb2', {
                  value: AddCustomEquipmentModal.bindingTemplate(),
                  onchange: function (event) {
                    AddCustomEquipmentModal.setBindingTemplateSelection(event && event.target ? event.target.value : '');
                  }
                }, [
                  m('option', { value: '' }, 'Do not bind'),
                  AddCustomEquipmentModal.templateOptions().map(function (templateOption) {
                    var optionValue = getBindingTemplateSelector(templateOption);
                    return m('option', { value: optionValue, key: templateOption.equipmentRid + '::bind' }, formatTemplateOptionLabel(templateOption));
                  })
                ]),
                AddCustomEquipmentModal.bindingTemplateLoading()
                  ? m('div.f6.gray.mb2', 'Loading template JSON...')
                  : '',
                AddCustomEquipmentModal.bindingTemplateLoadError()
                  ? m('div.f6.red.mb2', AddCustomEquipmentModal.bindingTemplateLoadError())
                  : ''
              ])
              : AddCustomEquipmentModal.bindingTemplateMode() === 'upload'
                ? m('div', [
                  m(fileInput, {
                    field: {
                      id: 'create-equipment-binding-template-upload',
                      name: 'Upload File',
                      accept: '.json,.txt'
                    },
                    onChange: AddCustomEquipmentModal.setBindingTemplateFile
                  }),
                  m('div.f6.mid-gray.mb2', AddCustomEquipmentModal.bindingTemplateFileName() || 'No file selected')
                ])
                : m('textarea.w-100.ba.b--mid-gray.br2.pa2.mb2', {
                  value: AddCustomEquipmentModal.bindingTemplateContent(),
                  placeholder: 'Paste binding template JSON here',
                  oninput: function (event) {
                    AddCustomEquipmentModal.bindingTemplateContent(event && event.target ? event.target.value : '');
                    AddCustomEquipmentModal.syncBindingRequiredDevices();
                  },
                  style: {
                    height: '35vh',
                    resize: 'vertical'
                  }
                }),
            AddCustomEquipmentModal.bindingRequiredDevices().length
              ? templateDeviceSelector.renderRequiredDeviceSelector({
                requiredDevices: AddCustomEquipmentModal.bindingRequiredDevices(),
                selections: AddCustomEquipmentModal.bindingDeviceSelections(),
                expandedIndex: AddCustomEquipmentModal.bindingExpandedDeviceIndex(),
                selectedNode: AddCustomEquipmentModal.bindingSelectedDevice,
                allowAddRemoveRows: true,
                sectionLabel: 'Required Devices',
                rowCountLabel: '',
                sectionHint: templateDeviceSelector.buildTargetDeviceHelpText(AddCustomEquipmentModal.bindingRequiredDevices().length),
                onToggleExpand: function (index) {
                  AddCustomEquipmentModal.bindingExpandedDeviceIndex(
                    AddCustomEquipmentModal.bindingExpandedDeviceIndex() === index ? -1 : index
                  );
                  AddCustomEquipmentModal.bindingSelectedDevice(null);
                },
                onSelect: function (index, selectedDevice) {
                  if (!selectedDevice || !selectedDevice['@rid']) return;
                  var requiredDevices = AddCustomEquipmentModal.bindingRequiredDevices();
                  var selections = AddCustomEquipmentModal.bindingDeviceSelections().slice();
                  var requiredDevice = requiredDevices[index] || {};
                  selections[index] = {
                    templateKey: requiredDevice.key,
                    rid: selectedDevice['@rid'],
                    name: selectedDevice.name ? String(selectedDevice.name) : '',
                    path: selectedDevice.path ? String(selectedDevice.path) : '',
                    error: ''
                  };
                  AddCustomEquipmentModal.bindingDeviceSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                  AddCustomEquipmentModal.bindingExpandedDeviceIndex(-1);
                  AddCustomEquipmentModal.bindingSelectedDevice(null);
                },
                onChangeRid: function (index, value) {
                  var requiredDevices = AddCustomEquipmentModal.bindingRequiredDevices();
                  var selections = AddCustomEquipmentModal.bindingDeviceSelections().slice();
                  var requiredDevice = requiredDevices[index] || {};
                  var nextRid = String(value || '').trim();
                  var existing = selections[index] || {};
                  selections[index] = {
                    templateKey: requiredDevice.key,
                    rid: nextRid,
                    name: existing.rid === nextRid ? (existing.name || '') : '',
                    path: existing.rid === nextRid ? (existing.path || '') : '',
                    error: ''
                  };
                  AddCustomEquipmentModal.bindingDeviceSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                },
                onBlurRid: function (index, value) {
                  var normalizedRid = templateDeviceSelector.normalizeRid(value);
                  templateDeviceSelector.resolveDeviceByRidWithError(normalizedRid)
                    .then(function (result) {
                      var selections = AddCustomEquipmentModal.bindingDeviceSelections().slice();
                      var existing = selections[index];
                      if (!existing) return;
                      if (templateDeviceSelector.normalizeRid(existing.rid) !== normalizedRid) return;
                      selections[index] = Object.assign({}, existing, {
                        rid: (result && result.device && result.device.rid) || existing.rid,
                        name: (result && result.device && result.device.name) || '',
                        path: (result && result.device && result.device.path) || '',
                        error: (result && result.error) || ''
                      });
                      AddCustomEquipmentModal.bindingDeviceSelections(selections);
                      AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                      m.redraw();
                    });
                },
                onClear: function (index) {
                  var requiredDevices = AddCustomEquipmentModal.bindingRequiredDevices();
                  var selections = AddCustomEquipmentModal.bindingDeviceSelections().slice();
                  var requiredDevice = requiredDevices[index] || {};
                  selections[index] = {
                    templateKey: requiredDevice.key,
                    rid: '',
                    name: '',
                    path: '',
                    error: ''
                  };
                  AddCustomEquipmentModal.bindingDeviceSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                },
                onDeleteRow: function (index) {
                  var selections = AddCustomEquipmentModal.bindingDeviceSelections().slice();
                  selections.splice(index, 1);
                  AddCustomEquipmentModal.bindingDeviceSelections(selections);
                  if (AddCustomEquipmentModal.bindingExpandedDeviceIndex() === index) {
                    AddCustomEquipmentModal.bindingExpandedDeviceIndex(-1);
                    AddCustomEquipmentModal.bindingSelectedDevice(null);
                  } else if (AddCustomEquipmentModal.bindingExpandedDeviceIndex() > index) {
                    AddCustomEquipmentModal.bindingExpandedDeviceIndex(AddCustomEquipmentModal.bindingExpandedDeviceIndex() - 1);
                  }
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                },
                onAddRow: function () {
                  var selections = AddCustomEquipmentModal.bindingDeviceSelections().slice();
                  selections.push({
                    templateKey: 'custom-device-' + Date.now() + '-' + selections.length,
                    rid: '',
                    name: '',
                    path: ''
                  });
                  AddCustomEquipmentModal.bindingDeviceSelections(selections);
                }
              })
              : '',
            AddCustomEquipmentModal.bindingTemplateDeviceParseError()
              ? m('div.f6.gray.mb2', AddCustomEquipmentModal.bindingTemplateDeviceParseError())
              : '',
            !AddCustomEquipmentModal.bindingRequiredDevices().length
              ? templateDeviceSelector.renderRequiredDeviceSelector({
                requiredDevices: [],
                selections: AddCustomEquipmentModal.bindingOverrideSelections(),
                expandedIndex: AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(),
                selectedNode: AddCustomEquipmentModal.bindingOverrideSelectedDevice,
                allowAddRemoveRows: true,
                sectionLabel: 'Target Device IDs',
                rowCountLabel: '',
                sectionHint: templateDeviceSelector.buildTargetDeviceHelpText(0),
                onToggleExpand: function (index) {
                  AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(
                    AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex() === index ? -1 : index
                  );
                  AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
                },
                onSelect: function (_index, selectedDevice) {
                  if (!selectedDevice || !selectedDevice['@rid']) return;
                  var rid = String(selectedDevice['@rid']);
                  var selections = AddCustomEquipmentModal.bindingOverrideSelections().slice();
                  selections[_index] = Object.assign({}, selections[_index] || {}, {
                    templateKey: (selections[_index] && selections[_index].templateKey) || ('override-device-' + _index),
                    rid: rid,
                    name: selectedDevice.name ? String(selectedDevice.name) : '',
                    path: selectedDevice.path ? String(selectedDevice.path) : '',
                    error: ''
                  });
                  AddCustomEquipmentModal.bindingOverrideSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                  AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(-1);
                  AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
                },
                onChangeRid: function (_index, value) {
                  var nextRid = String(value || '').trim();
                  var selections = AddCustomEquipmentModal.bindingOverrideSelections().slice();
                  var existing = selections[_index] || {};
                  selections[_index] = {
                    templateKey: existing.templateKey || ('override-device-' + _index),
                    rid: nextRid,
                    name: existing.rid === nextRid ? String(existing.name || '') : '',
                    path: existing.rid === nextRid ? String(existing.path || '') : '',
                    error: ''
                  };
                  AddCustomEquipmentModal.bindingOverrideSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                },
                onBlurRid: function (_index, value) {
                  var normalizedRid = templateDeviceSelector.normalizeRid(value);
                  templateDeviceSelector.resolveDeviceByRidWithError(normalizedRid)
                    .then(function (result) {
                      var selections = AddCustomEquipmentModal.bindingOverrideSelections().slice();
                      var existing = selections[_index];
                      if (!existing) return;
                      if (templateDeviceSelector.normalizeRid(existing.rid) !== normalizedRid) return;
                      selections[_index] = Object.assign({}, existing, {
                        rid: (result && result.device && result.device.rid) || existing.rid,
                        name: (result && result.device && result.device.name) || '',
                        path: (result && result.device && result.device.path) || '',
                        error: (result && result.error) || ''
                      });
                      AddCustomEquipmentModal.bindingOverrideSelections(selections);
                      AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                      m.redraw();
                    });
                },
                onClear: function (_index) {
                  var selections = AddCustomEquipmentModal.bindingOverrideSelections().slice();
                  var existing = selections[_index] || {};
                  selections[_index] = {
                    templateKey: existing.templateKey || ('override-device-' + _index),
                    rid: '',
                    name: '',
                    path: '',
                    error: ''
                  };
                  AddCustomEquipmentModal.bindingOverrideSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                },
                onDeleteRow: function (_index) {
                  var selections = AddCustomEquipmentModal.bindingOverrideSelections().slice();
                  selections.splice(_index, 1);
                  if (!selections.length) {
                    selections.push({
                      templateKey: 'override-device-0',
                      rid: '',
                      name: '',
                      path: ''
                    });
                  }
                  AddCustomEquipmentModal.bindingOverrideSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                  if (AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex() === _index) {
                    AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(-1);
                    AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
                  } else if (AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex() > _index) {
                    AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex() - 1);
                  }
                },
                onAddRow: function () {
                  var selections = AddCustomEquipmentModal.bindingOverrideSelections().slice();
                  selections.push({
                    templateKey: 'override-device-' + Date.now() + '-' + selections.length,
                    rid: '',
                    name: '',
                    path: ''
                  });
                  AddCustomEquipmentModal.bindingOverrideSelections(selections);
                  AddCustomEquipmentModal.bindingTargetDeviceIds(templateDeviceSelector.composeTargetDeviceIds(selections));
                  AddCustomEquipmentModal.bindingOverrideExpandedDeviceIndex(-1);
                  AddCustomEquipmentModal.bindingOverrideSelectedDevice(null);
                }
              })
              : '',
            AddCustomEquipmentModal.bindingResult()
              ? m('div.mt3', [
                m('div.f6.b.mb1', 'Last Binding Result'),
                m('div.f6.mb1', 'Applied: ' + Number(AddCustomEquipmentModal.bindingResult().appliedCount || 0) + ', Failed: ' + Number(AddCustomEquipmentModal.bindingResult().failedCount || 0)),
                m('div.f7.gray', 'Exit code: ' + (typeof AddCustomEquipmentModal.bindingResult().exitCode === 'number' ? AddCustomEquipmentModal.bindingResult().exitCode : 'n/a')),
              ])
              : ''
          ])
          : ''
      ])
      : '',

  ])
}

function base64ToUint8Array(base64String) {
  var decoded = window.atob(base64String || '');
  var bytes = new Uint8Array(decoded.length);
  for (var i = 0; i < decoded.length; i++) {
    bytes[i] = decoded.charCodeAt(i);
  }
  return bytes;
}

function decodeByteArrayToText(byteArray) {
  if (typeof TextDecoder !== 'undefined') {
    return new TextDecoder('utf-8').decode(byteArray);
  }
  var text = '';
  for (var i = 0; i < byteArray.length; i++) {
    text += String.fromCharCode(byteArray[i]);
  }
  return decodeURIComponent(escape(text));
}

function extractFirstErrorMessage(error) {
  if (!error) return '';
  if (typeof error === 'string') return error;
  if (typeof error.error === 'string' && error.error) return error.error;
  if (typeof error.message === 'string' && error.message) return error.message;
  if (Array.isArray(error.errors) && error.errors.length) {
    var firstError = error.errors[0];
    if (typeof firstError === 'string') return firstError;
    if (firstError && typeof firstError.message === 'string') return firstError.message;
  }
  return '';
}

function normalizeTemplateEntries(templates) {
  if (!Array.isArray(templates)) return [];
  return templates
    .map(function (template) {
      var normalized = template && typeof template === 'object'
        ? template
        : { name: typeof template === 'string' ? template : '' };
      var equipmentRid = normalized.equipmentRid ? String(normalized.equipmentRid).trim() : '';
      return {
        name: normalized.name ? String(normalized.name).trim() : '',
        equipmentRid: equipmentRid
      };
    })
    .filter(function (template) {
      return template.name || template.equipmentRid;
    });
}

function normalizeTemplateRidParam(rid) {
  return String(rid || '').trim().replace(/^#/, '');
}

function getBindingTemplateSelector(templateOption) {
  if (!templateOption) return '';
  var templateName = templateOption.name ? String(templateOption.name).trim() : '';
  if (templateName) return templateName;
  return formatTemplateId(templateOption.equipmentRid);
}

function formatTemplateOptionLabel(templateOption) {
  var displayName = templateOption && templateOption.name ? String(templateOption.name).trim() : 'Default';
  return displayName + ' (Template ID ' + formatTemplateId(templateOption && templateOption.equipmentRid) + ')';
}

function formatTemplateId(rid) {
  var normalizedRid = String(rid || '').trim();
  if (!normalizedRid) return '';
  return normalizedRid.startsWith('#') ? normalizedRid : ('#' + normalizedRid);
}

function extractTemplateRoomOptions(templateEquipmentRecord) {
  if (!templateEquipmentRecord || !Array.isArray(templateEquipmentRecord.out_containsLocation)) return [];
  var roomsByRid = {};
  templateEquipmentRecord.out_containsLocation.forEach(function (containsLocationEdge) {
    var roomRecord = containsLocationEdge && containsLocationEdge.in;
    if (!roomRecord || !roomRecord['@rid']) return;
    roomsByRid[roomRecord['@rid']] = roomRecord;
  });
  return Object.keys(roomsByRid).map(function (rid) { return roomsByRid[rid]; });
}

function formatTemplateRoomLabel(roomRecord) {
  if (!roomRecord) return '';
  var name = roomRecord.name ? String(roomRecord.name) : 'Room';
  var roomNumber = roomRecord.roomNumber ? String(roomRecord.roomNumber).trim() : '';
  return roomNumber ? `${name} ${roomNumber}` : name;
}

function extractRequestErrors(error) {
  if (!error) return ['Unable to create equipment.'];
  if (Array.isArray(error)) return error;
  if (typeof error === 'string') return [error];
  if (error.errors && Array.isArray(error.errors)) return error.errors;
  if (typeof error.error === 'string') return [error.error];
  if (typeof error.message === 'string') return [error.message];
  return ['Unable to create equipment.'];
}

function bindingSummaryToMessages(bindingSummary) {
  var failures = bindingSummary && Array.isArray(bindingSummary.failures) ? bindingSummary.failures : [];
  var base = ['Equipment was created, but binding reported failures.'];
  base.push('Applied: ' + Number(bindingSummary && bindingSummary.appliedCount || 0) + ', Failed: ' + Number(bindingSummary && bindingSummary.failedCount || 0) + '.');
  failures.slice(0, 5).forEach(function (failure, idx) {
    var ridText = failure && failure.rid ? String(failure.rid) : 'n/a';
    var errorText = failure && failure.error ? String(failure.error) : 'Unknown binding error.';
    base.push('Failure ' + (idx + 1) + ' (' + ridText + '): ' + errorText);
  });
  if (failures.length > 5) {
    base.push('Showing first 5 binding failures.');
  }
  return base;
}

function bindingErrorToMessages(bindingError) {
  var base = ['Equipment was created, but binding request failed.'];
  var extracted = extractRequestErrors(bindingError);
  extracted.forEach(function (message) {
    base.push(message);
  });
  if (bindingError && bindingError.stderr) {
    base.push('stderr: ' + String(bindingError.stderr));
  }
  return base;
}
module.exports = AddCustomEquipmentModal;
